import { initSwiper } from './swiper'

export const Events = () => {

  const el = document.querySelector('.events')
  const filters = el?.querySelectorAll('.events__filter')

  if (!el) return

  filters.forEach(filter => {
    filter.addEventListener('click', (e) => {
      filters.forEach(filter => filter.classList.remove('active'))
      e.currentTarget.classList.add('active')
    })
  })
  
  htmx.on('htmx:afterSwap', () => {
    Events()
    initSwiper()
  })
}

export default () => { }